import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function OtherActs() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Acts & Guidelines", link: "/acts" },
    { label: "Responsibilities under other Acts", active: true },
  ];

  const acts = [
    {
      title: "POCSO Act, 2012",
      description: "Protection of Children from Sexual Offences Act, 2012",
      link: "/PocsoAct",
    },
    {
      title: "RTE Act, 2009",
      description: "Right of Children to Free and Compulsory Education Act, 2009",
      link: "/RteAct",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="Responsibilities under other Acts"
        breadcrumbs={breadcrumbs}
      />

      {/* Acts List Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4 justify-content-center">

            {acts.map((act, index) => (
              <div key={index} className="col-md-6 col-lg-5">
                <div className="card shadow-sm border-0 h-100 hover-shadow">
                  <div className="card-body">
                    <h5 className="card-title text-primary fw-bold">
                      {act.title}
                    </h5>
                    <p className="card-text text-secondary">{act.description}</p>
                    <Link
                      to={act.link}
                      className="btn btn-primary rounded-pill"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

    </div>
  );
}
